import AiBlueImg from '@/assets/images/web/ai_blue.png';
import AiRedImg from '@/assets/images/web/ai_red.png';
import AiGreenImg from '@/assets/images/web/ai_green.png';
// import { changeFavicon } from '@/utils/Page';
// import { useEffect } from 'react';
const imgMap = {
    1: AiBlueImg,
    2: AiRedImg,
    3: AiGreenImg
};
const AgentLogo = ({ theme = 1, ...props }) => {
    // useEffect(() => {
    //     changeFavicon(imgMap[theme]);
    // }, [theme]);
    return <img src={imgMap[theme]} {...props} alt="" />;
};
export default AgentLogo;
